import { render, staticRenderFns } from "./MultipleFileInput.vue?vue&type=template&id=baad7994&"
import script from "./MultipleFileInput.vue?vue&type=script&lang=js&"
export * from "./MultipleFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports